import {fromJS} from "immutable";
import MAP_STYLE from "./map-style-basic-v8.json";
import LABEL_STYLE from "./map-style-basic-v8-labels.json";

export const baseStyle = fromJS(MAP_STYLE);
export const countryLabelStyle = LABEL_STYLE.country;
export const cityLabelStyle = LABEL_STYLE.city;
export const placeLabelStyle = LABEL_STYLE.place;
